<div class="modal-main_container">
  <div class="modal-main_container-header">
    <span class="modal-main_container-header-title">
      {{modalTitle}}
    </span>

    <div class="modal-main_container-header-actions-container">
      <button mat-flat-button mat-dialog-close>
        <mat-icon>
          close
        </mat-icon>
      </button>
    </div>
  </div>

  <div class="modal-main_container-body">
    <div class="modal-main_container-body-search_bar">
      <mat-form-field appearance="outline">
        <mat-label>Buscar</mat-label>
        <input matInput placeholder="Criterio de búsqueda" [formControl]="searchInputControl" appKeyboardInput>
        <mat-icon matSuffix style="cursor: pointer" (click)="RequestRecords()">search</mat-icon>
      </mat-form-field>
    </div>

    <div class="modal-main_container-body-table_container">
      <cl-table
        [Id]="tableId"
        [HasPaginator]="true"
        [HasItemsSelection]="false"
        [ShouldSplitPascal]="false"
        [MappedColumns]="tableMappedColumns"
        [Records]="tableRecords"
        [ShouldPaginateRequest]="tableShouldPaginateRequest"
        [RecordsCount]="tableRecordsCount"
        [Buttons]="tableButtons"
        [ItemsPeerPage]="itemsPerPage"
        [PageSizeEditable]="true"
        ScrollHeight="{{tableScrollHeight}}"
      >
      </cl-table>
    </div>
  </div>

</div>
